'use client';
import Tooltip from '@/components/atoms/Tooltip/Tooltip';
import useProduct from '@/contexts/ProductProvider';
import { ProductSummary } from '@/services/ecommerce/utils/helper';
import usePixalEvent from '@/services/event/usePixalEvent';
import cls from 'classnames';
import { useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import styles from '../product.module.scss';

const WrapperDProducts = () => {
	const { selectedVariant, product, loading, globalData } = useProduct();
	const { EventViewContent } = usePixalEvent();

	const d_product: any = ProductSummary(selectedVariant);
	useEffect(() => {
		EventViewContent({
			items: product,
			value: d_product?.price
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const formatPrice = (price) => {
		const floatPrice = parseFloat(price).toFixed(2); // Ensures two decimal places
		const [whole, fraction] = floatPrice.toString().split('.');

		return (
			<span>
				<span className='fw-700 text-20'>{whole}</span>
				{fraction && <span className='fw-600 text-16'>.{fraction}</span>}
			</span>
		);
	};

	return (
		<>
			{!loading ? (
				<div className={cls('d-flex flex-column gap-8')}>
					<div className=''>
						<span className='d-flex text-16 text-grey900 fw-500'>
							<Tooltip content={`${d_product?.unit_label}`} placement='top'>
								{d_product?.unit_label}
							</Tooltip>
						</span>
					</div>
					<div className='d-flex justify-space-between items-center'>
						<strong className='d-flex items-center gap-10'>
							<span className='text-16 text-grey900 fw-700'>৳ {formatPrice(d_product?.price)}</span>

							{d_product?.price !== d_product?.mrp && (
								<>
									<div className='text-grey500' style={{ textDecoration: 'line-through' }}>
										৳ {d_product?.mrp}
									</div>
									<span className={cls('ml-16 fw-500 text-14 text-error', styles.discount)}>
										<span>{d_product?.discountPercentage}% OFF</span>{' '}
									</span>
								</>
							)}
						</strong>
					</div>
				</div>
			) : (
				<div className='d-flex items-center gap-10 p-10'>
					<ContentLoader
						speed={2}
						width={'100%'}
						height={50}
						viewBox='0 0 auto 50'
						backgroundColor='#f3f3f3'
						foregroundColor='#ecebeb'>
						<rect x='0' y='0' rx='0' ry='0' width='100' height='15' />
						<rect x='0' y='20' rx='0' ry='0' width='20' height='15' />
						<rect x='30' y='20' rx='0' ry='0' width='20' height='15' />
						<rect x='60' y='20' rx='0' ry='0' width='40' height='15' />
					</ContentLoader>
					<ContentLoader
						speed={2}
						width={200}
						height={40}
						viewBox='0 0 200 40'
						backgroundColor='#f3f3f3'
						foregroundColor='#ecebeb'>
						<rect x='0' y='0' rx='0' ry='0' width='200' height='50' />
					</ContentLoader>
				</div>
			)}
		</>
	);
};

export default WrapperDProducts;
